/** The pause menu (GDD §7.1): Resume, Restart, Settings and Quit. */
import { add, el } from './dom.ts';

export type PauseAction = 'resume' | 'restart' | 'settings' | 'quit';

export interface PauseMenu {
  el: HTMLElement;
  buttons: HTMLButtonElement[];
}

export function buildPauseMenu(doc: Document, act: (a: PauseAction) => void): PauseMenu {
  const box = el(doc, 'div', 'hw-menu hw-glass');
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-label', 'Paused');
  add(box, el(doc, 'h2', 'hw-menu-title', 'PAUSED'));
  const items: [PauseAction, string][] = [
    ['resume', 'RESUME'],
    ['restart', 'RESTART'],
    ['settings', 'SETTINGS'],
    ['quit', 'QUIT'],
  ];
  const buttons = items.map(([a, label]) => {
    const b = add(box, el(doc, 'button', a === 'resume' ? 'hw-menu-btn hw-primary' : 'hw-menu-btn', label));
    b.type = 'button';
    b.dataset.action = a;
    b.addEventListener('click', () => act(a));
    return b;
  });
  return { el: box, buttons };
}
